module.exports = __webpack_public_path__ + "img/p-04.5bbe39f9.webp";